























import {Vue, Component} from 'vue-property-decorator'
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase";

@Component({})
export default class Tab4 extends TabBase {
}
